import React from 'react';
import { Shield, Calendar, Hash, AlertTriangle , Info} from 'lucide-react';
import { Json } from 'api-client';



interface AssetTLSCertificateProps {
  certificate: any;
}

export const AssetTLSCertificate: React.FC<AssetTLSCertificateProps> = ({ certificate }) => {
  const isExpiringSoon = () => {
    if (!certificate.validTo) return false;
    const validTo = new Date(certificate.validTo);
    const now = new Date();
    const daysUntilExpiry = Math.ceil((validTo.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
    return daysUntilExpiry <= 30;
  };

  return (
    <div className="bg-[#0F1629] rounded-xl p-6 border border-gray-800/50">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Shield className="h-5 w-5 text-blue-500" />
          <h2 className="text-lg font-semibold text-white">TLS Certificate</h2>
        </div>
        <div className="flex items-center space-x-1 text-green-500">
        <Info className="h-4 w-4" />
            <span className="text-xs">{certificate.tls_version ? certificate.tls_version.toUpperCase() : 'Unknown'}</span>
          </div>

        {isExpiringSoon() && (
          <div className="flex items-center space-x-1 text-yellow-500">
            <AlertTriangle className="h-4 w-4" />
            <span className="text-xs">Expiring soon</span>
          </div>
        )}
      </div>

      <div className="space-y-4">
        <div>
          <div className="text-sm text-gray-400">Subject</div>
          <div className="text-sm font-medium text-white mt-1">{certificate.subject_cn	 || 'Unknown'}</div>
        </div>

        <div>
          <div className="text-sm text-gray-400">Issuer</div>
          <div className="text-sm font-medium text-white mt-1">{certificate.issuer_cn || 'Unknown'}</div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-sm text-gray-400">Valid From</div>
            <div className="flex items-center space-x-2 mt-1">
              <Calendar className="h-4 w-4 text-gray-500" />
              <span className="text-sm text-white">
                {certificate.not_before ? new Date(certificate.not_before).toLocaleDateString() : 'Unknown'}
              </span>
            </div>
          </div>

          <div>
            <div className="text-sm text-gray-400">Valid To</div>
            <div className="flex items-center space-x-2 mt-1">
              <Calendar className="h-4 w-4 text-gray-500" />
              <span className="text-sm text-white">
                {certificate.not_before ? new Date(certificate.not_before).toLocaleDateString() : 'Unknown'}
              </span>
            </div>
          </div>
        </div>

        <div>
          <div className="text-sm text-gray-400">Serial Number</div>
          <div className="flex items-center space-x-2 mt-1">
            <Hash className="h-4 w-4 text-gray-500" />
            <span className="text-sm font-mono text-white break-words overflow-hidden">{certificate.serial	 || 'Unknown'}</span>
          </div>
        </div>
        <div>
          <div className="text-sm text-gray-400">Cipher </div>
          <div className="flex items-center space-x-2 mt-1">
            <Hash className="h-4 w-4 text-gray-500" />
            <span className="text-sm font-mono text-white">{certificate.cipher	 || 'Unknown'}</span>
          </div>
        </div>


        <div>
          <div className="text-sm text-gray-400">Subject Alternative Names</div>
          <div className="flex flex-wrap gap-2 mt-2">
            {(certificate.subject_an	 || []).map((san: string, index: number) => (
              <span
                key={index}
                className="px-2 py-1 text-xs rounded-lg bg-gray-800/50 text-gray-300"
              >
                {san}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};